import { useSelector } from 'react-redux';
import { Surface } from '@vst/beam';

import { StepCounter } from '@app/components/StepCounter';
import { useScreenResolution } from '@app/hooks';
import { selectIsPreinstall } from '@app/redux';

import CollapsibleDisconnectCart from '../components/CollapsibleCart';
import { TotalSteps } from '../types';

import styles from './DisconnectPageLayout.module.scss';

type PageLayoutProps = {
  header: React.ReactNode;
  step: number;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  children?: React.ReactNode;
};

export const DisconnectPageLayout = ({ header, step, leftContent, rightContent, children }: PageLayoutProps) => {
  const { isMedium, isSmall, isExtraSmall } = useScreenResolution();
  const isMobile = isSmall || isExtraSmall || isMedium;

  const hasPreinstall = useSelector(selectIsPreinstall);
  const totalSteps = hasPreinstall ? TotalSteps.PREINSTALL : TotalSteps.DEFAULT;

  return (
    <>
      {isMobile && <CollapsibleDisconnectCart />}
      <div className={styles['page']}>
        <div className={styles['header']}>
          {header}
          <StepCounter step={step} maxSteps={totalSteps} />
        </div>

        <div className={styles['content']}>
          {leftContent && (
            <Surface radius="16px" className={styles['leftCard']}>
              {leftContent}
            </Surface>
          )}
          {rightContent && !isMobile && (
            <Surface radius="16px" p="48px" className={styles['rightCard']}>
              {rightContent}
            </Surface>
          )}
          {children}
        </div>
      </div>
    </>
  );
};
